import React, { useEffect, useState } from 'react';
import Button from "components/CustomButtons/Button.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { Modal, Form, Col } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import useAuth from "hooks/useAuth";

import api from "assets/services/api";
import { SortByAlphaSharp } from '@material-ui/icons';


function ModalChangeProduct(props) {


    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    }

    const [br, setBR] = React.useState(false);

    const [amount, setAmount] = useState(0);
    const [controlSnack, setControlSnack] = useState(false);
    const { storageId } = useAuth();

    const showNotification = place => {
        switch (place) {
            case "br":
                if (!br) {
                    setBR(true);
                    setTimeout(function () {
                        setBR(false);
                        setControlSnack(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    useEffect(() => {
    }, []);

    useEffect(() => {
        if (controlSnack) {
            showNotification("br")
        }
    }, [controlSnack]);

    async function handleTransfer(e) {
        e.preventDefault();
        const response = await api.post('/product_client/change/'+ storageId + '/' +props.props.id_product,{
            amount: amount
        });
        props.getStoragesOfProducts();
        setControlSnack(true);
        props.onHide();
    }

    return (
        <Modal
            {...props}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Transferir produtos para o {storageId === 1 ? 'Distrito Federal' : 'Goias'}
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleTransfer}>
                <Modal.Body>
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridAmount">
                            <Form.Label>Quantidade para transferir em caixas</Form.Label>
                            <Form.Control onChange={event => setAmount(event.target.value)} type="number" placeholder="Quantidade de produtos a serem transferidos em caixas" />
                        </Form.Group>
                    </Form.Row>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex justify-content-center">
                        <Button color="success" type="submit">
                            Transferir
                        </Button>
                        <Snackbar
                            place="br"
                            color="success"
                            icon={AddAlert}
                            message="Produtos transferidos com sucesso"
                            open={br}
                            closeNotification={() => setBR(false)}
                            close
                        />
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default ModalChangeProduct;